import common from '../../../../common';
export default common.directives.controlBack;
